import React from 'react';

export const LoadHeader = () => (
  <div className="flex justify-between items-center mb-8">
    <div>
      <h1 className="text-2xl font-semibold">Lieferscheine</h1>
      <p className="text-gray-500">Lieferscheine als PDF-Datei wählen</p>
    </div>
    <div className="flex items-center space-x-2">
      <img 
        src="/logos/UserLogo.png"
        alt="Profile" 
        className="h-8 w-8 rounded-full"
      />
      <span className="text-gray-700 font-medium">Autobahn GmbH</span>
    </div>
  </div>
);
